// src/js-coding/Footer.js
import React, { useState } from 'react';
import { NavLink } from 'react-router-dom'; // ✅ import NavLink
import '../css-coding/Footer.css';
import Logo from '../assets/Logo.png';
import { useNavigate } from 'react-router-dom';
import Popup from "./popup.jsx"; 

const Footer = () => {
  const navigate = useNavigate(); // ✅ useNavigate hook
  const [coursesOpen, setCoursesOpen] = useState(false);

  const handleScroll = (sectionId) => {
  if (window.location.pathname !== '/PrivacyPolicy&TermsofServices') {
    navigate('/PrivacyPolicy&TermsofServices');
    setTimeout(() => {
      const el = document.getElementById(sectionId);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 600);
  } else {
    const el = document.getElementById(sectionId);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
};


    const navItems = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About' },
    { path: '/services', label: 'Services' },
    { path: '/portfolio', label: 'Portfolio' },
    { path: '/blog', label: 'Blog' },
    { path: '/case-studies', label: 'Case Studies' },
    { path: '#', label: 'Our Courses', type: 'popup' },
   
  ];

  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="footer-contact">
          <a href="mailto:contact@thegrowthsecret.in">
            <span className="icon-wrapper"> <span className="icon">+</span></span> contact@thegrowthsecret.in
          </a>
        </div>

        <div className="footer-nav">
         

          <div>
            <h4>Navigation</h4>
            <ul>
              {/* ✅ Use navItems dynamically */}
              {/* {navItems.map((item) => (
                <li key={item.path}>
                  <NavLink
                    to={item.path}
                    className={({ isActive }) => (isActive ? 'active' : '')}
                    end={item.path === '/'}
                     onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                  >
                    {item.label}
                  </NavLink>
                </li>
              ))} */}

              {navItems.map((item) => (
  <li key={item.label}>
    {item.type === 'popup' ? (
      <a
        href="#"
        onClick={(e) => {
          e.preventDefault();
          setCoursesOpen(true);
        }}
      >
        {item.label}
      </a>
    ) : (
      <NavLink
        to={item.path}
        className={({ isActive }) => (isActive ? 'active' : '')}
        end={item.path === '/'}
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      >
        {item.label}
      </NavLink>
    )}
  </li>
))}
            </ul>
          </div>
          <div>
            <h4>Social</h4>
            <ul>
              <li><a href="https://www.instagram.com/thegrowthsecretmedia" target="_blank" 
     rel="noopener noreferrer" >Instagram ↗</a></li>
              <li><a href="https://linkedin.com/company/thegrowthsecretmedia" target="_blank" 
     rel="noopener noreferrer" >linkedin ↗</a></li>
              <li><a href="https://www.youtube.com/@thegrowthsecretmedia" target="_blank" 
     rel="noopener noreferrer" >youtube ↗</a></li>
            </ul>
          </div>
        </div>  

        
      </div>

      <div className="footer-logo">
         <img src={Logo} alt="Your Brand Logo" />
        </div>

      <div className="footer-bottom">
        <span>© 2026 The Growth Secret Media® All rights reserved.</span>
        <div className="footer-links">
      
 <span
  onClick={() => handleScroll('privacy-policy')}
  style={{ cursor: 'pointer' }}
>
  Privacy Policy
</span>

<span
  onClick={() => handleScroll('terms-of-services')}
  style={{ cursor: 'pointer', marginLeft: '20px' }}
>
  Terms of Services
</span>

        </div>
       
      </div>

      <Popup
  isOpen={coursesOpen}
  onClose={() => setCoursesOpen(false)}
/>
    </footer>
  );
};

export default Footer;
